<div class="page">
	<div class="page-header">
		<app-navbar [showBackButton]="true" />
	</div>

	<div class="page-content align-items-center">
		<div class="row page-content-row text-center">
			<div class="col-12 content-row pb-2 px-0">
				<h4 class="fw-bold text-start header">{{ 'Consents' | translate }}</h4>
			</div>

			<div class="col-12 content-row px-0 mt-3">
				<div class="d-flex content-row btn-action mx-auto bg-white w-100">
					<div class="col-10 col-md-11 title text-start h-100 px-0">
						{{ 'Consent_General' | translate }}
						@if (consent_general() != undefined && consent_general()?.Date?.Iso)
						{
						<p class="mb-0 description">
							{{ 'Consent_Given' | translate }}
							{{
								consent_general()!.Date.Iso |
							date: 'dd.MM.yyyy'
							}}
						</p>
						}
					</div>
					<div class="col-2 col-md-1 checkbox checkbox-container my-auto">
						<div class="form-switch">
							<input
								type="checkbox"
								class="form-check-input"
								id="consent_general"
								[checked]="consent_general_checked()"
								(change)="consentChanged(consent_general())"
								[disabled]="consent_general() == undefined"
							>
							<label
								class="form-check-label cursor-pointer"
								for="consent_general"
							></label>
						</div>
					</div>
				</div>
			</div>
			@if (consent_counselling() != undefined) {
			<div class="col-12 content-row px-0 mt-3">
				<div class="d-flex content-row btn-action mx-auto bg-white w-100">
					<div class="col-10 col-md-11 title text-start h-100 px-0">
						{{ 'Consent_HealthCounseling' | translate }}
						@if (consent_counselling() != undefined &&
						consent_counselling()?.Date?.Iso) {
						<p class="mb-0 description">
							{{ 'Consent_Given' | translate }}
							{{ consent_counselling()!.Date.Iso | date: 'dd.MM.yyyy' }}
						</p>
						}
					</div>
					<div class="col-2 col-md-1 checkbox checkbox-container my-auto">
						<div class="form-switch">
							<input
								type="checkbox"
								class="form-check-input"
								id="consent_counselling"
								[checked]="consent_counselling_checked()"
								(change)="consentChanged(consent_counselling())"
								[disabled]="consent_counselling() == undefined"
							>
							<label
								class="form-check-label cursor-pointer"
								for="consent_counselling"
							></label>
						</div>
					</div>
				</div>
			</div>
			} @if (consent_healthscreening() != undefined) {
			<div class="col-12 content-row px-0 mt-3">
				<div class="d-flex content-row btn-action mx-auto bg-white w-100">
					<div class="col-10 col-md-11 title text-start h-100 px-0">
						{{ 'Consent_HealthScreening' | translate }}
						@if (consent_healthscreening() != undefined &&
						consent_healthscreening()?.Date?.Iso) {
						<p class="mb-0 description">
							{{ 'Consent_Given' | translate }}
							{{ consent_healthscreening()!.Date.Iso | date: 'dd.MM.yyyy' }}
						</p>
						}
					</div>
					<div class="col-2 col-md-1 checkbox checkbox-container my-auto">
						<div class="form-switch">
							<input
								type="checkbox"
								class="form-check-input"
								id="consent_healthscreening"
								[checked]="consent_healthscreening_checked()"
								(change)="consentChanged(consent_healthscreening())"
								[disabled]="consent_healthscreening() == undefined"
							>
							<label
								class="form-check-label cursor-pointer"
								for="consent_healthscreening"
							></label>
						</div>
					</div>
				</div>
			</div>
			} @if (consent_wpa() != undefined) {
			<div class="col-12 content-row px-0 mt-3">
				<div class="d-flex content-row btn-action mx-auto bg-white w-100">
					<div class="col-10 col-md-11 title text-start h-100 px-0">
						{{ 'Consent_WPA' | translate }}
						@if (consent_wpa() != undefined && consent_wpa()?.Date?.Iso) {
						<p class="mb-0 description">
							{{ 'Consent_Given' | translate }}
							{{
								consent_wpa()!.Date.Iso |
							date: 'dd.MM.yyyy'
							}}
						</p>
						}
					</div>
					<div class="col-2 col-md-1 checkbox checkbox-container my-auto">
						<div class="form-switch">
							<input
								type="checkbox"
								class="form-check-input"
								id="consent_wpa"
								[checked]="consent_wpa_checked()"
								(change)="consentChanged(consent_wpa())"
								[disabled]="consent_wpa() == undefined"
							>
							<label
								class="form-check-label cursor-pointer"
								for="consent_wpa"
							></label>
						</div>
					</div>
				</div>
			</div>
			} @if (consent_healthcheck() != undefined) {
			<div class="col-12 content-row px-0 mt-3">
				<div class="d-flex content-row btn-action mx-auto bg-white w-100">
					<div class="col-10 col-md-11 title text-start h-100 px-0">
						{{ 'Consent_HealthCheck' | translate }}
						@if (consent_healthcheck() != undefined &&
						consent_healthcheck()?.Date?.Iso) {
						<p class="mb-0 description">
							{{ 'Consent_Given' | translate }}
							{{ consent_healthcheck()!.Date.Iso | date: 'dd.MM.yyyy' }}
						</p>
						}
					</div>
					<div class="col-2 col-md-1 checkbox checkbox-container my-auto">
						<div class="form-switch">
							<input
								type="checkbox"
								class="form-check-input"
								id="consent_healthcheck"
								[checked]="consent_healthcheck_checked()"
								(change)="consentChanged(consent_healthcheck())"
								[disabled]="consent_healthcheck() == undefined"
							>
							<label
								class="form-check-label cursor-pointer"
								for="consent_healthcheck"
							></label>
						</div>
					</div>
				</div>
			</div>
			} @if (consent_pulse() != undefined) {
			<div class="col-12 content-row px-0 mt-3">
				<div class="d-flex content-row btn-action mx-auto bg-white w-100">
					<div class="col-10 col-md-11 title text-start h-100 px-0">
						{{ 'Consent_Pulse' | translate }}
						@if (consent_pulse() != undefined && consent_pulse()?.Date?.Iso) {
						<p class="mb-0 description">
							{{ 'Consent_Given' | translate }}
							{{
								consent_pulse()!.Date.Iso |
							date: 'dd.MM.yyyy'
							}}
						</p>
						}
					</div>
					<div class="col-2 col-md-1 checkbox checkbox-container my-auto">
						<div class="form-switch">
							<input
								type="checkbox"
								class="form-check-input"
								id="consent_pulse"
								[checked]="consent_pulse_checked()"
								(change)="consentChanged(consent_pulse())"
								[disabled]="consent_pulse() == undefined"
							>
							<label
								class="form-check-label cursor-pointer"
								for="consent_pulse"
							></label>
						</div>
					</div>
				</div>
			</div>
			} @if (consent_whistleblower() != undefined) {
			<div class="col-12 content-row px-0 mt-3">
				<div class="d-flex content-row btn-action mx-auto bg-white w-100">
					<div class="col-10 col-md-11 title text-start h-100 px-0">
						{{ 'Consent_Whistleblower' | translate }}
						@if (consent_whistleblower() != undefined &&
						consent_whistleblower()?.Date?.Iso) {
						<p class="mb-0 description">
							{{ 'Consent_Given' | translate }}
							{{ consent_whistleblower()!.Date.Iso | date: 'dd.MM.yyyy' }}
						</p>
						}
					</div>
					<div class="col-2 col-md-1 checkbox checkbox-container my-auto">
						<div class="form-switch">
							<input
								type="checkbox"
								class="form-check-input"
								id="consent_whistleblower"
								[checked]="consent_whistleblower_checked()"
								(change)="consentChanged(consent_whistleblower())"
								[disabled]="consent_whistleblower() == undefined"
							>
							<label
								class="form-check-label cursor-pointer"
								for="consent_whistleblower"
							></label>
						</div>
					</div>
				</div>
			</div>
			} @if (consent_counselling() != undefined) {
			<div class="col-12 content-row px-0 mt-3">
				<div class="d-flex content-row btn-action mx-auto bg-white w-100">
					<div class="col-10 col-md-11 title text-start h-100 px-0">
						{{ 'Consent_HealthCounseling' | translate }}
						@if (consent_counselling() != undefined &&
						consent_counselling()?.Date?.Iso) {
						<p class="mb-0 description">
							{{ 'Consent_Given' | translate }}
							{{ consent_counselling()!.Date.Iso | date: 'dd.MM.yyyy' }}
						</p>
						}
					</div>
					<div class="col-2 col-md-1 checkbox checkbox-container my-auto">
						<div class="form-switch">
							<input
								type="checkbox"
								class="form-check-input"
								id="consent_counselling"
								[checked]="consent_counselling_checked()"
								(change)="consentChanged(consent_counselling())"
								[disabled]="consent_counselling() == undefined"
							>
							<label
								class="form-check-label cursor-pointer"
								for="consent_counselling"
							></label>
						</div>
					</div>
				</div>
			</div>
			}
		</div>

		<ng-template #consentRevokeModal let-modal>
			<div class="modal-header">
				<h4 class="modal-title text-body" id="consent-revoke-modal-title">
					{{ 'Information' | translate }}
				</h4>
			</div>
			<div class="modal-body text-body">
				<div class="col-12 px-0">
					<div class="row message w-100 bg-white mx-0">
						<p class="col-12 text-center">
							{{ revokeConsentText() | translate }}
						</p>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button
					type="button"
					class="btn btn-outline-dark"
					(click)="revokeConsentCancelled()"
				>
					{{ 'CloseBtn'| translate }}
				</button>
				<button type="button" class="btn btn-primary" (click)="revokeConsent()">
					{{ 'Confirm' | translate }}
				</button>
			</div>
		</ng-template>
	</div>
</div>
